import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import { sendWebViewMsg } from 'utils/bridge'
import { UserInfoActions } from 'store/actionCreators'
import server from 'server/serverController2'

import Presenter from 'components/presenters/campaign/PersonalDataUpdateModal'

export default function PersonalDataUpdateModal({ visible, setVisible, campaignNo }) {
  const history = useHistory()

  const handleKakaoSync = async () => {
    const response = await sendWebViewMsg({ action: 'REQ_KAKAO_LOGIN' }).catch((err) => {
      console.log('err from msg')
      console.log(err)
    })
    const accessToken = response.data.token.accessToken
    console.log(accessToken)
    const form = {
      access_token: accessToken,
    }

    const result = await server.postRequestData(`auth/kakao/sync`, form)

    let authToken = null

    if (result.success === 1) {
      history.push(`/write/personal?redirect_path=/campaign/${campaignNo}/join`)
    } else {
      const errData = result.error.res_data
      //Signup
      if (errData['detail_code'] === 'SOCIAL_DATA_NOT_EXIST') {
        authToken = errData['auth_token']
      } else {
        //error fail to login
        return
      }
    }
  }

  if (!visible) return null
  return (
    <ModalWrapper>
      <Presenter setVisible={setVisible} onKakaoSync={handleKakaoSync} campaignNo={campaignNo} />
    </ModalWrapper>
  )
}

const ModalWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 400;
`
